import React from "react";
import {
  useVitalsSubdomainRedirect,
  REDIRECT_COUNTDOWN_SECONDS,
} from "../../hooks/useVitalsSubdomainRedirect";
import RedirectCountdown from "../CustomComponents/RedirectCountdown";

const VitalsRedirectHandler: React.FC = () => {
  const { showCountdown, handleRedirect } = useVitalsSubdomainRedirect();

  return (
    <RedirectCountdown
      visible={showCountdown}
      onRedirect={handleRedirect}
      duration={REDIRECT_COUNTDOWN_SECONDS}
    />
  );
};

export default VitalsRedirectHandler;
